
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[shopId]",
      function () {
        return require("private-next-pages/shop/[shopId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[shopId]"])
      });
    }
  